import { COMPANY } from "@/data/content";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Chapter } from "@/components/Reveal";

const DOCS = {
  privacy: {
    title: "Privacy Policy",
    chapter: "Privacy",
    sections: [
      ["Overview", `${COMPANY.name} ("Xtreme Exotics," "we," "us") respects your privacy. This policy describes how we handle information submitted through this website, including the Fleet Partner application.`],
      ["Information We Collect", "Business and contact information you submit through the Fleet Partner application (name, job title, email, phone number, business details and waterfront operation details), as well as standard technical data such as browser type and pages visited."],
      ["How We Use Information", "We use submitted information to review Fleet Partner applications, contact applicants about their application, operate and improve the program, and meet legal or contractual obligations. We do not sell your personal information."],
      ["Cookies and Analytics", "This site may use cookies and analytics tools to understand traffic and improve the experience. You can accept or decline non-essential cookies through the consent banner, and control cookies through your browser settings."],
      ["Data Retention and Security", "Application data is stored securely and retained only as long as needed for program review, operations and legal requirements. We apply reasonable administrative and technical safeguards."],
      ["Your Choices", `To request access, correction or deletion of your information, contact us at ${COMPANY.email} or ${COMPANY.phone}.`],
      ["Contact", `${COMPANY.name}, ${COMPANY.address1}, ${COMPANY.address2}. Phone: ${COMPANY.phone}. Email: ${COMPANY.email}.`],
    ],
  },
  terms: {
    title: "Terms and Conditions",
    chapter: "Terms",
    sections: [
      ["Acceptance of Terms", `By using this website you agree to these Terms and Conditions. This website is operated by ${COMPANY.name} and is intended for business audiences interested in the Fleet Partner Program.`],
      ["No Consumer Rentals", "This website does not offer consumer Jet Car rentals or bookings. All rental experiences are operated by approved Fleet Partners in their own markets."],
      ["No Guarantee of Approval or Income", "Submitting a Fleet Partner application does not guarantee approval, deployment, exclusivity or any level of income. Revenue examples on this site are illustrative only. Actual results depend on pricing, completed eligible rental hours, weather, seasonality, customer demand, refunds, chargebacks, taxes, fees and the terms of the final Fleet Partner Agreement."],
      ["Program Terms", "Participation in the Fleet Partner Program is governed exclusively by a final, signed Fleet Partner Agreement. Website content is informational and does not modify that agreement."],
      ["Intellectual Property", "All content, branding and materials on this website are the property of Xtreme Exotics Watersports LLC and may not be reproduced without written permission."],
      ["Limitation of Liability", "To the fullest extent permitted by law, Xtreme Exotics Watersports LLC is not liable for indirect or consequential damages arising from use of this website or reliance on its content."],
      ["Contact", `${COMPANY.name}, ${COMPANY.address1}, ${COMPANY.address2}. Phone: ${COMPANY.phone}. Email: ${COMPANY.email}.`],
    ],
  },
  accessibility: {
    title: "Accessibility Statement",
    chapter: "Accessibility",
    sections: [
      ["Our Commitment", `${COMPANY.name} is committed to providing a website that is accessible to the widest possible audience, including visitors using assistive technologies.`],
      ["Measures We Take", "We aim for semantic page structure, descriptive alternative text on meaningful images, keyboard-navigable interactive elements, sufficient color contrast between text and backgrounds, and visible focus states."],
      ["Ongoing Effort", "Accessibility is an ongoing effort. We review the site as content and features evolve and work to address barriers as they are identified."],
      ["Feedback", `If you experience any difficulty using this website, contact us at ${COMPANY.email} or ${COMPANY.phone} and we will work to provide the information or service you need through an accessible alternative.`],
      ["Contact", `${COMPANY.name}, ${COMPANY.address1}, ${COMPANY.address2}. Phone: ${COMPANY.phone}. Email: ${COMPANY.email}.`],
    ],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc] || DOCS.privacy;
  return (
    <div data-testid={`legal-${doc}-page`}>
      <Navbar />
      <main className="bg-ink pb-24 pt-36 lg:pt-44">
        <div className="container-x max-w-3xl">
          <Chapter index="·" label={d.chapter} />
          <h1 className="font-display text-3xl font-extrabold tracking-tight text-offwhite sm:text-4xl" data-testid="legal-title">
            {d.title}
          </h1>
          <p className="mt-3 font-mono text-xs tracking-widest text-muted/70">Last updated: July 2026</p>
          <div className="mt-12 space-y-10">
            {d.sections.map(([h, body]) => (
              <section key={h}>
                <h2 className="font-display text-lg font-bold text-aqua">{h}</h2>
                <p className="mt-3 text-sm leading-relaxed text-muted">{body}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
